// extracted by mini-css-extract-plugin
module.exports = {"base":"QuizIncomplete_base__22yLe","alert":"QuizIncomplete_alert__2i5v0"};